<template>
  <div class="row">
    <div class="card-body table-responsive bg-white">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6 col-md-6 d-flex align-items-stretch flex-column">
          <div class="card bg-light d-flex flex-fill">
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-9">
                  <h2 class="lead"><b>{{ remolque.placa }}</b></h2>
                </div>
                <div class="col-3 text-center">
                <img 
                  v-if="remolque.link_fotografia"
                  :src="uri_docs + remolque.link_fotografia" 
                  alt="user-avatar" 
                  class="img-circle img-fluid">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-md-12"
          v-for="paquete in remolque.paquetes"
          :key="paquete.id"
        >
          <div class="card card-ligth card-outline collapsed-card">
            <div class="card-header pt-2 pb-2">
              <h3 class="card-title">
                <i class="far fa-folder"></i>
                {{ paquete.nombre }}
              </h3>
              <div class="card-tools">
                <button
                  type="button"
                  class="btn btn-tool"
                  data-card-widget="collapse"
                  data-toggle="tooltip"
                  title="Collapse"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body table-responsive">
              <div class="row">
                <div class="col-md-12">
                  <table
                    id="docs"
                    class="table table-bordered table-hover table-sm text-nowrap"
                  >
                    <thead class="bg-dark">
                      <tr>
                        <th>Documento</th>
                        <th>Referencia</th>
                        <th>Emisor</th>
                        <th>Fecha Emisión</th>
                        <th>Fecha Vencimiento</th>
                        <th>Verificado</th>
                        <th>Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="documento in paquete.documentos"
                        :key="documento.id"
                        v-bind:class="
                          documento.pivot.relevante &&
                          !validaDoc(remolque.documentos_files, documento, 2)
                            ? 'alert-default-danger'
                            : 'alert-default-success'
                        "
                      >
                        <td class="text-wrap" v-text="documento.descripcion"></td>
                        <td>
                          <p v-if="validaDoc(remolque.documentos_files, documento, 1)">
                            {{ remolque.documentos_files.find((file) => file.documento_id === documento.id).referencia}}
                          </p>
                        </td>
                        <td>
                          <p v-if="validaDoc(remolque.documentos_files, documento, 1)">
                            {{ remolque.documentos_files.find((file) => file.documento_id === documento.id).emisor }}
                          </p>
                        </td>
                        <td class="text-center">
                          <p v-if="validaDoc(remolque.documentos_files, documento, 1)">
                            {{ remolque.documentos_files.find((file) => file.documento_id === documento.id).fecha_emision }}
                          </p>
                        </td>
                        <td class="text-center">
                          <p v-if="validaDoc(remolque.documentos_files, documento, 1)">
                            {{ remolque.documentos_files.find((file) => file.documento_id === documento.id).fecha_vencimiento }}
                          </p>
                        </td>
                        <td class="text-center">
                          <i 
                            class="fa"
                            :class="
                              btnVerificado[paquete.id + '-' + documento.id] ? 
                              'fa-check text-success' : 
                              'fa-times-circle text-danger' "
                          ></i>
                        </td>
                        <td>
                          <a
                            target="_blank"
                            class="btn btn-primary btn-sm"
                            :href="uri_docs + remolque.documentos_files.find((file) => file.documento_id === documento.id).link"
                            v-if="validaDoc(remolque.documentos_files, documento, 2)"
                          >
                            <i class="fa fa-download"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DocumentoRemolque",
  data() {
    return {
      cargando: false,
      remolque: [],
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
      btnVerificado: {},
    };
  },
  methods: {
    getRemolque(id) {
      axios.get("/api/admin/remolques/" + id).then((response) => {
        this.remolque = response.data[0];
        this.getVerificado();
      });
    },

    validaDoc(files, documento, tipo) {
      if (files.find((file) => file.documento_id === documento.id) !== undefined) {
        if (tipo == 2) {
          if (files.find((file) => file.documento_id === documento.id).link !== "") {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },

    getVerificado() {
      for (let i = 0; i < this.remolque.paquetes.length; i++) {
        const paquete = this.remolque.paquetes[i];
        for (let j = 0; j < paquete.documentos.length; j++) {
          const documento = paquete.documentos[j];
          let verif = this.remolque.documentos_files.find(
            (file) => file.documento_id === documento.id
          );

          if (verif !== undefined) {
            this.btnVerificado[
              paquete.id + "-" + documento.id
            ] = this.remolque.documentos_files.find(
              (file) => file.documento_id === documento.id
            ).verificado;
          } else {
            this.btnVerificado[paquete.id + "-" + documento.id] = false;
          }
        }
      }
    },
  },
};
</script>
